import { render, staticRenderFns } from "./birth-index.vue?vue&type=template&id=60782326&scoped=true&"
import script from "./birth-index.vue?vue&type=script&lang=js&"
export * from "./birth-index.vue?vue&type=script&lang=js&"
import style0 from "./birth-index.vue?vue&type=style&index=0&id=60782326&prod&lang=scss&"
import style1 from "./birth-index.vue?vue&type=style&index=1&id=60782326&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60782326",
  null
  
)

export default component.exports